<template>
    <x-page title="Template Statistik">
        <template #header-actions>
            <x-create-button
                url="/admin/group-statistic-templates/create"
                :disabled="isLoading"
                v-if="can('createGroupStatisticTemplates')"
            />
        </template>

        <x-filter-box :onFilter="() => handleFilter()" :onReset="resetFilter">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Label">
                        <input
                            class="form-control"
                            type="text"
                            v-model="filters.search"
                            @keyup.enter="() => handleFilter()"
                            placeholder="Masukkan label template"
                        />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>

        <x-table :headers="['#', 'Label', 'Action']" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link
                        :to="`/admin/group-statistic-templates/${resource.id}`"
                        title="Klik untuk lihat detail"
                    >
                        {{ resource.label }}
                    </router-link>
                </td>
                <td>
                    <x-quick-edit-button
                        :url="`/admin/group-statistic-templates/${resource.id}/edit`"
                        :disabled="isLoading"
                        v-if="can('updateGroupStatisticTemplates')"
                    />
                    <x-quick-delete-button
                        @click="deleteResource(resource)"
                        :disabled="isLoading"
                        v-if="can('deleteGroupStatisticTemplates')"
                    />
                </td>
            </tr>
        </x-table>

        <x-pagination
            v-if="shouldRenderPagination"
            :pagination="meta"
            :query="$route.query"
        />
    </x-page>
</template>

<script>
import XActionButton from "../../components/XActionButton.vue";
import XAjaxDropdown from "../../components/XAjaxDropdown.vue";
import XCheckboxWrapper from "../../components/XCheckboxWrapper.vue";
import XCreateButton from "../../components/XCreateButton.vue";
import XExcelImportModal from "../../components/XExcelImportModal.vue";
import XFilterBox from "../../components/XFilterBox.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XPage from "../../components/XPage.vue";
import XPagination from "../../components/XPagination.vue";
import XQuickActionButton from "../../components/XQuickActionButton.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";
import XQuickViewButton from "../../components/XQuickViewButton.vue";
import XSmsBlastLabel from "../../components/XSmsBlastLabel.vue";
import XTable from "../../components/XTable.vue";
import {
    deletePrompt,
    handleGeneralXhrError,
} from "../../helpers";
import FilterableMixin from "../../mixins/FilterableMixin";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";

const defaultFilters = {
    search: null,
};

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
    },
    components: {
        XCreateButton,
        XTable,
        XPage,
        XFormGroup,
        XFilterBox,
        XAjaxDropdown,
        XActionButton,
        XExcelImportModal,
        XCheckboxWrapper,
        XPagination,
        XQuickActionButton,
        XQuickViewButton,
        XQuickEditButton,
        XQuickDeleteButton,
        XSmsBlastLabel,
    },
    created() {
        this.preselectFilters(defaultFilters);
        this.handleFilter(this.$route.query.page || 1).catch(() => {
            this.fetchResources();
        });
    },
    data() {
        return {
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
        };
    },
    methods: {
        deleteResource(resource) {
            deletePrompt({
                name: resource.label,
                onConfirm: () => {
                    this.isLoading = true;
                    const request = axios
                        .delete(`/api/group-statistic-templates/${resource.id}`)
                        .then(() => {
                            this.$notify({
                                type: "success",
                                title: `Berhasil`,
                                text: `${resource.label} dihapus!`,
                            });
                            this.fetchResources();
                        });
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false;
                    });
                },
            });
        },
        fetchResources(route = this.$route) {
            this.isLoading = true;
            const request = axios
                .get("/api/group-statistic-templates", {
                    params: {
                        ...route.query,
                        without_global_scopes: 1,
                    },
                })
                .then((response) => {
                    this.resources = response.data.data;
                    this.setMeta(response);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleFilter(page = 1) {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: page,
                }),
            });
        },
        resetFilter() {
            this.filters = { ...defaultFilters };
            this.handleFilter();
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
};
</script>